<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="84.616"
    height="84.614"
    xmlns:v="https://vecta.io/nano"
  >
    <defs>
      <clipPath id="A">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-387.232 -445.008)" />
      </clipPath>
      <clipPath id="B">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-386.54 -395.59)" />
      </clipPath>
      <clipPath id="C">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-374.917 -438.962)" />
      </clipPath>
      <clipPath id="D">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-396.581 -401.37)" />
      </clipPath>
      <clipPath id="E">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-358.222 -439.727)" />
      </clipPath>
      <clipPath id="F">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-411.44 -408.979)" />
      </clipPath>
      <clipPath id="G">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-359.043 -423.017)" />
      </clipPath>
      <clipPath id="H">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-359.083 -411.396)" />
      </clipPath>
      <clipPath id="I">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-411.439 -425.426)" />
      </clipPath>
      <clipPath id="J">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-403.215 -439.67)" />
      </clipPath>
      <clipPath id="K">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-364.918 -401.37)" />
      </clipPath>
      <clipPath id="L">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-380.971 -436.353)" />
      </clipPath>
      <clipPath id="M">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-377.429 -398.354)" />
      </clipPath>
    </defs>
    <g transform="translate(-465.304 -523.891)">
      <path
        d="M0 0l-21.715-29.469 13.14.121-8.197-26.185L8.83-22.983l-12.225.016zm0 0h.005zm-3.153-7.65l-2.221-15.024a2 2 0 0 1 .464-1.598c.379-.441.931-.694 1.512-.695l8.115-.01-16.326-20.756 4.942 15.787c.192.611.079 1.276-.302 1.789a2 2 0 0 1-1.606.809l-9.155-.084z"
        transform="matrix(1.333333 0 0 -1.333333 516.30973 529.17667)"
        clip-path="url(#A)"
        fill="#fff"
      />
      <g
        stroke-miterlimit="10"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-width="2"
        stroke="#fff"
        fill="none"
      >
        <path
          d="M0 0l2.433-9.079"
          transform="matrix(1.333333 0 0 -1.333333 515.38653 595.06653)"
          clip-path="url(#B)"
        />
        <path
          d="M0 0l-2.415 9.01"
          transform="matrix(1.333333 0 0 -1.333333 499.88933 537.2376)"
          clip-path="url(#C)"
        />
        <path
          d="M0 0l6.636-6.635"
          transform="matrix(1.333333 0 0 -1.333333 528.77427 587.35987)"
          clip-path="url(#D)"
        />
        <path
          d="M0 0l6.614-6.613"
          transform="matrix(1.333333 0 0 -1.333333 477.62933 536.218)"
          clip-path="url(#E)"
        />
        <path
          d="M0 0l-9.025 2.418"
          transform="matrix(1.333333 0 0 -1.333333 548.5864 577.2148)"
          clip-path="url(#F)"
        />
        <path
          d="M0 0l-9.065 2.429"
          transform="matrix(1.333333 0 0 -1.333333 478.72373 558.4976)"
          clip-path="url(#G)"
        />
        <path
          d="M0 0l-9.105-2.44"
          transform="matrix(1.333333 0 0 -1.333333 478.77733 573.99253)"
          clip-path="url(#H)"
        />
        <path
          d="M0 0l-8.985-2.408"
          transform="matrix(1.333333 0 0 -1.333333 548.58573 555.28507)"
          clip-path="url(#I)"
        />
        <path
          d="M0 0l-6.556-6.557"
          transform="matrix(1.333333 0 0 -1.333333 537.62013 536.2936)"
          clip-path="url(#J)"
        />
        <path
          d="M0 0l-6.694-6.695"
          transform="matrix(1.333333 0 0 -1.333333 486.5572 587.35987)"
          clip-path="url(#K)"
        />
        <path
          d="M0 0l-.181.001c-10.575 0-19.148-8.573-19.148-19.147 0-8.032 4.945-14.908 11.957-17.751"
          transform="matrix(1.333333 0 0 -1.333333 507.9616 540.71573)"
          clip-path="url(#L)"
        />
        <path
          d="M0 0a19.28 19.28 0 0 1 3.361-.294 19.15 19.15 0 0 1 19.147 19.147c0 8.85-6.004 16.297-14.161 18.492"
          transform="matrix(1.333333 0 0 -1.333333 503.23853 591.38173)"
          clip-path="url(#M)"
        />
      </g>
    </g>
  </svg>
</template>
